import { last, first, get } from 'lodash'
import { RouterView } from 'vue-router'
import fuxiSdk from '@didi/fuxi-sdk'
import { trackEvent } from '@/plugins/plugin-init-omega'
import router from '@/router'
import {
  FUXI_ENV,
  APP_KEYS,
  BASE_SIM_APP_KEYS,
  APPKEY_PREFIX,
  BASE_SIM_FLAG,
  fuxiComponents,
} from './config'
import { IS_SIM } from '@/config/constants'

const FUXI_CACHE_KEY = `${FUXI_ENV}_${APP_KEYS.join(',')}`
let apps_obtain_start_time = null
let apps_obtain_end_time = null

export async function initLowCode() {
  try {
    const appsInfo = await getAppsInfo()
    const routes = []
    Object.keys(appsInfo).forEach(app => {
      const appInfo = appsInfo[app]
      const route = formatAppToRoute(appInfo)
      routes.push(route)
    })
    routes.forEach(route => {
      router.addRoute(route)
    })
    console.info('log => initLowCode appsInfo', appsInfo)
    console.info('log => initLowCode routes', routes)
  } catch (error) {
    console.warn(error)
    trackEvent('tech_gattaran_lowcode_apps_info_error_st', '低码应用菜单转路由配置失败', {
      error,
    })
  }
}
async function getAppsInfo() {
  let appsInfo
  try {
    const IS_SIM_UNBASE = IS_SIM && !APPKEY_PREFIX.includes(BASE_SIM_FLAG)
    const appKeys = IS_SIM_UNBASE ? [...APP_KEYS, ...BASE_SIM_APP_KEYS] : APP_KEYS
    apps_obtain_start_time = new Date().getTime()
    appsInfo = await fuxiSdk.init({
      env: FUXI_ENV,
      appKeys,
    })
    apps_obtain_end_time = new Date().getTime()
    trackEvent('tech_gattaran_lowcode_apps_info_success_st', '低码应用配置获取成功', {
      config: appKeys,
      time: apps_obtain_start_time && apps_obtain_end_time ? apps_obtain_end_time - apps_obtain_start_time : null
    })
    // sim环境下实现低码配置的流量穿梭
    if (IS_SIM_UNBASE) {
      APP_KEYS.forEach(key => {
        if (appsInfo[key]) {
          const BASE_SIM_APP_KEY = key.replace(/sim\d+/, BASE_SIM_FLAG)
          delete appsInfo[BASE_SIM_APP_KEY]
        }
      })
    }
    // 缓存本地用于接口失败降级
    localStorage.setItem(FUXI_CACHE_KEY, JSON.stringify(appsInfo))
  } catch (err) {
    console.error(err)
    trackEvent('gattaran_lowcode_page_fuxi_sdk_init_error_bt', '低码应用配置获取失败', {
      error: err,
    })
    // sdk 获取失败降级从local获取配置
    appsInfo = localStorage.getItem(FUXI_CACHE_KEY) || '{}'
    appsInfo = JSON.parse(appsInfo)
  }
  return appsInfo
}
function formatAppToRoute(info) {
  const base = '/' + info.basic.base
  const route = []
  const pathStack = [base]
  const currentRoute = [route]
  const setRedirect = routeConfig => {
    if (routeConfig.redirect || routeConfig.props) return
    const firstChildren = first(routeConfig.children)
    pathStack.push(firstChildren?.path)
    routeConfig.redirect = pathStack.join('/')
    pathStack.pop()
  }
  const menuToRoute = menu => {
    const { type, redirect = '', url, pageId, name, path, menuRender, meta } = menu
    const metaMap = {}
    if (meta && Array.isArray(meta)) {
      meta.forEach(({ key, value }) => {
        // meta的值支持配置为json字符串，在此处进行解析
        try {
          value = JSON.parse(value)
        } catch (error) {
          console.warn('meta值解析失败，请确实是否为正确JSON字符串', value)
        }
        metaMap[key] = value
      })
    }
    const pageInfo = info.pageMaps[pageId]
    const fullPath = pathStack.join('/')
    // 菜单分组
    if (type === 0 || redirect) {
      return {
        path,
        name: fullPath,
        redirect,
        component: {
          render(h) {
            return h(RouterView)
          },
        },
        children: [],
      }
    } else {
      return {
        path,
        name: fullPath, // gattarn中菜单使用路由的name跳转,需配置name为fullpath
        props: {
          url,
          assetsUrl: get(pageInfo, 'lastRelease.assetsProUrl'),
          schemaUrl: get(pageInfo, 'lastRelease.schemaUrl'),
        },
        meta: {
          pageID: pageId,
          title: name,
          menuRender: !!menuRender,
          ...metaMap,
        },
        component: fuxiComponents[type],
        children: [],
      }
    }
  }
  const loopMenus = menus => {
    const current = last(currentRoute)
    menus.forEach(menu => {
      pathStack.push(menu.path)
      const routeConfig = menuToRoute(menu)
      current.push(routeConfig)
      if (menu.children && menu.children.length) {
        currentRoute.push(routeConfig.children)
        loopMenus(menu.children)
        setRedirect(routeConfig)
        currentRoute.pop()
      }
      pathStack.pop()
    })
  }
  loopMenus(info.menus)
  return {
    path: base,
    component: {
      render(h) {
        return h(RouterView, { key: this.$route.path })
      },
    },
    children: route,
  }
}
